import { Workbox } from "workbox-window";

export function registerServiceWorker() {
  // Track page load time to avoid showing update dialogs immediately after reload
  const pageLoadTime = Date.now();

  // Register service worker for production
  if (process.env.NODE_ENV === "production" && "serviceWorker" in navigator) {
    const wb = new Workbox("/sw.js");

    wb.addEventListener("installed", (event) => {
      if (event.isUpdate) {
        console.log("New service worker installed, ready to update");
      } else {
        console.log("Service worker installed for the first time");
      }
    });

    wb.addEventListener("waiting", () => {
      console.log("New service worker is waiting to activate");

      // Skip confirm dialog if page was reloaded less than 10 seconds ago
      const timeSinceLoad = Date.now() - pageLoadTime;
      if (timeSinceLoad < 10000) {
        console.log("Skipping update dialog - page reloaded recently");
        wb.messageSkipWaiting();
        return;
      }

      const updateAccepted = confirm(
        "A new version of the application is available. Click OK to update."
      );

      if (updateAccepted) {
        wb.messageSkipWaiting();
      }
    });

    wb.addEventListener("controlling", () => {
      console.log("New service worker is now controlling the page");
      window.location.reload();
    });

    // Listen for version update messages from service worker
    navigator.serviceWorker.addEventListener("message", (event) => {
      if (event.data && event.data.type === "VERSION_UPDATE") {
        console.log("Version update detected:", event.data.payload);

        // Skip confirm dialog if page was reloaded less than 10 seconds ago
        const timeSinceLoad = Date.now() - pageLoadTime;
        if (timeSinceLoad < 10000) {
          window.location.reload();
          return;
        }

        const updateAccepted = confirm(
          "A new version of the application is available. The page will reload to apply updates."
        );

        if (updateAccepted) {
          window.location.reload();
        }
      }
    });

    // Register the service worker
    wb.register()
      .then((registration) => {
        console.log("Service worker registered:", registration);

        // Check for updates every 1 minute
        setInterval(() => {
          registration?.update();
          // Also ask service worker to check version
          if (registration?.active) {
            registration.active.postMessage({ type: "CHECK_VERSION" });
          }
        }, 60 * 1000);
      })
      .catch((error) => {
        console.error("Service worker registration failed:", error);
      });
  }
}
